export const DEFAULT_PRECISION_FORMATS = {
    days: 'DD. MM. YYYY',
    months: 'MM. YYYY',
    years: 'YYYY',
    hours: 'DD. MM. YYYY HH',
    minutes: 'DD. MM. YYYY HH:mm',
    seconds: 'DD. MM. YYYY HH:mm:ss',
}

export const DEFAULT_PRECISION = 'YYYYM'
